import { useEffect, useId, useMemo, useState } from "react";
import { useHash } from "react-use";

export const useModalState = <T>(initialData?: T, key?: string) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | undefined>(initialData);
  const idRandom = useId();

  const [hash, setHash] = useHash();

  const id = key || idRandom;

  useEffect(() => {
    hash.substring(1) === id ? setIsOpen(true) : setIsOpen(false);
  }, [hash, id]);

  return useMemo(
    () => ({
      isOpen,
      data,
      open: () => {
        setTimeout(() => {
          setHash(id);
        }, 0);
      },
      openWith: (value: React.SetStateAction<T | undefined>) => {
        setData(value);
        setTimeout(() => {
          setHash(id);
        }, 0);
      },
      close: () => {
        if (hash.substring(1) === id) {
          setHash(" ");
          window.history.pushState(null, "", " ");
        }
      },
      reset: () => {
        if (hash.substring(1) === id) {
          setData(undefined);
          setHash(" ");
          window.history.pushState(null, "", " ");
        }
      },
    }),
    [isOpen, data, id, setHash, hash],
  );
};
